import { createZodDto } from 'nestjs-zod';
import { z } from 'zod';
import { Gender, Parameters } from '../../enums';
import { arrayToZodEnum } from '../../util';

export const userInfo = z.object({
  email: z.string().email(),
  height: z.number().int().min(1).max(300),
  yearOfBirth: z.number().int().min(1900).max(new Date().getFullYear()),
  gender: z.enum(arrayToZodEnum(Object.values(Gender))),
  nickName: z.string().nullable().optional(),
  marketingConsent: z.boolean().optional().default(false),
  fsUpdateDismissedAt: z.coerce.date().nullable().optional(),
  goal: z
    .object({
      name: z.string(),
      parameter: z.enum(arrayToZodEnum(Object.values(Parameters))),
      value: z.string(),
    })
    .nullish(),
});

export class UserInfo extends createZodDto(userInfo) {}
